define([
    "skylark-utils/fx"
], function(fx) {
    return fx;
});
